import { render, staticRenderFns } from "./Reportes_old.vue?vue&type=template&id=fd498618&"
import script from "./Reportes_old.vue?vue&type=script&lang=js&"
export * from "./Reportes_old.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports